
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.142 54c-1.774 0-7.74-3.139-13.491-10.4C9.792 37.473 4 26.9 4 11.368a3.66 3.66 0 013.174-3.41A100.117 100.117 0 0028.142 2a100.254 100.254 0 0020.97 5.957 3.662 3.662 0 013.174 3.411c0 15.536-5.792 26.105-10.651 32.236C35.884 50.861 29.917 54 28.142 54zM14.923 23.839a2.963 2.963 0 00-2.1.867 2.948 2.948 0 000 4.187l8.813 8.763a2.988 2.988 0 004.21 0l17.625-17.53a2.948 2.948 0 000-4.187 2.99 2.99 0 00-4.21 0L23.738 31.377l-6.709-6.671a2.967 2.967 0 00-2.106-.867z","fill":"#222"}})])
          )
        }
      }
    